<template>
  <v-layout column class="footer-list">
    <v-divider color="grey" />
    <v-list class="footer-list">
      <v-list-tile dark v-for="item in footerItems" :key="item.key" :to="{path: item.link}">
        <v-list-tile-content>
          <v-list-tile-title class="footer-text" v-text="item.name"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-flex class="bottom-space" />
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      footerItems: [
        { key: 'tos', name: 'Terms Of Services', link: '/tos' },
        { key: 'pp', name: 'Privacy Policy', link: '/pp' },
      ]
    }),
    methods: {

    },
    computed: {
      ...mapGetters([

      ])
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {

    }
  }
</script>

<style scoped>
.footer-list {
  background-color: #05151F;
}
.footer-text {
  color: #ffffff;
}
.bottom-space {
  height: 350px;
}
</style>
